import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { timeLeft } from 'routes/Documents/routes/OnlineRehabilitation/utils';

import ContentColumns from '../../components/ContentColumns';

const View6 = (_, { fmString, formValues, onChange }) => {
  const finished = path(['rehab6', 'finished'], formValues);

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString(`onlineRehabilitation.rehab6.6.header`)}</h2>
            <br />
            <div>{fmString(`onlineRehabilitation.rehab6.6.text`)}</div>
            <br />
            <div>
              {fmString('onlineRehabilitation.nextRehab')} {timeLeft(finished)}
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

View6.contextTypes = {
  fmString: func,
  formValues: object,
  onChange: func,
};
export default View6;
